import { React, useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { createHttpClient, handleRemoteError } from '../../utilities/httpclient';
import { AbdsButton } from '@abds/react-bindings';
import createUserSessionActivity from '../../utilities/usersessiontracking';
import { createDisplayAreaMessengerContext, DisplayAreaMessenger } from '../displayareamessenger/DisplayAreaMessenger';
import { APPLICATION_API_ENDPOINT } from '../../utilities/constants';
import { useKeyPressEnter } from '../../customhooks/useKeyPressEnter';

import '../../styles/main.css';
import '../../styles/searchquerycontainer.css';
import '../../styles/absgtable.css';

export function OnboardingHome(props) {
    const rSubmitButton = useRef(null);

    const [dashboardData, setDashboardData] = useState(null);
    let [messageContext, setMessageContext] = useState(createDisplayAreaMessengerContext());

    const navigate = useNavigate();

    const showErrorMessage = msg => {
        setMessageContext({});
        messageContext = createDisplayAreaMessengerContext();
        messageContext.error.message = msg;
        setMessageContext(messageContext);
    };

    const handleNewVendor = () => navigate('/onboarding/vendor');

    useKeyPressEnter(rSubmitButton);

    useEffect(() => {
        createUserSessionActivity(window.location.pathname);
        setDashboardData([]);
    }, []);

    return (
        <div>
            <h3>Onboarding</h3>
            <hr className="abcblue" />

            <DisplayAreaMessenger context={messageContext} />

            <h4>Dashboard</h4>
            {
                dashboardData === null &&
                (<h4 className="center">Loading onboarding vendor data...</h4>)
            }
            {
                dashboardData?.length === 0 &&
                (<>
                    <h4 className="center">No onboarding vendor data</h4>
                    <div className="alignright">
                        <AbdsButton onClick={handleNewVendor}>Create New Vendor</AbdsButton>
                    </div>
                </>)
            }
        </div>
    );
}